module.exports = __webpack_public_path__ + "img/tab-inbox-inactive.a037965.png";